import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createElementVNode as _createElementVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74839f4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "filterSetContainer",
  class: "filter-set-container"
}
const _hoisted_2 = {
  key: 0,
  class: "search-results-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "filter-set-search-options"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_PillSearchInput = _resolveComponent("PillSearchInput")!
  const _component_PillButton = _resolveComponent("PillButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Typography, {
      ref: "filterSetLabel",
      component: "div",
      class: "navigation-text filter-set-label"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ], undefined, true),
      _: 1
    }, 512),
    _createElementVNode("div", {
      ref: "filterOptions",
      class: "filter-set",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.focusFilter && _ctx.focusFilter(...args)))
    }, [
      _createVNode(_TransitionGroup, {
        name: "filter-set-options",
        class: "filter-set-options",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_ctx.filterCategory === 'custom' || _ctx.filterType === 'tag')
            ? (_openBlock(), _createBlock(_component_PillSearchInput, {
                key: "search",
                class: "filter-button",
                "search-input-active": _ctx.searchInputActive,
                onToggleInput: _ctx.onToggleSearchInput,
                onInput: _ctx.onSearchInput
              }, null, 8, ["search-input-active", "onToggleInput", "onInput"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (option) => {
            return (_openBlock(), _createBlock(_component_PillButton, {
              key: option.value,
              label: option.label,
              class: _normalizeClass(['filter-button', { selected: _ctx.isSelected(option) }]),
              onClick: ($event: any) => (_ctx.selectFilter(option, _ctx.filterType))
            }, null, 8, ["label", "class", "onClick"]))
          }), 128))
        ], undefined, true),
        _: 1
      })
    ], 544),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.searchInputActive && _ctx.searchTerm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.searchTerm && _ctx.searchResults.length === 0)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: "noresults",
                    variant: "body2",
                    class: "search-results-text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" No results found ")
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.searchResults.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (option) => {
                      return (_openBlock(), _createBlock(_component_PillButton, {
                        key: option.value,
                        label: option.label,
                        "max-lines": 1,
                        class: "filter-button",
                        onClick: ($event: any) => (_ctx.selectFilter(option, _ctx.filterType))
                      }, null, 8, ["label", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_5
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ], 512))
}